

export default function Image(props) {

		let {data} = props
		//make 12 if no data default to xs. if no xs then it will be 12
		let xs = data && data.xs ? data.xs : '12'
		let sm = data && data.sm ? data.sm : xs
		let md = data && data.md ? data.md : sm
		let lg = data && data.lg ? data.lg : md

		let className= 'col-xs-'+ xs + ' col-sm-'+ sm + ' col-md-'+ md + ' col-lg-'+ lg

		return(
				<div id={data.richId} className={className} style={{padding: '10px'}} >
						<img src={data.imgSrc} style={{width: '100%'}} />
				</div>
    )


}



// WEBPACK FOOTER //
// ./components/contentTypes/image/image.js